<template>
    <div></div>
</template>

<script>
    export default {
        name: "CreateUser"
    }
</script>

<style scoped>

</style>